<div class="d-flex align-items-center">
    @for(lang of languageViewModels; track lang.code; let isLast = $last){
    <div>
      <div [class.me-3]="!isLast">
        <i [class]="lang.icon" [class.selected]="selectedLanguage === lang.code"
          (click)="setLanguage($event, lang.code)">
          <div class="checkmark-position-box">
            <app-checkmark-indicator [isChecked]="lang.showCheckmark" [showIsNotCheckedIndicator]="lang.showNotCheckedIndicator" />
          </div>
          <div class="required-position-box" [class.selected]="selectedLanguage === lang.code">
            @if (lang.required && selectedLanguage !== lang.code){
             <span style="font-style: normal;">*</span>
            }
          </div>
        </i>
        </div>
    </div>
    }
</div>